import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { Person, CalendarToday, Description } from '@mui/icons-material';
import { DocumentView } from '../../../../../../services/RefundService/types/documentTypes';
import { formatDate } from '../utils';

interface DocumentMetadataSectionProps {
  document: DocumentView;
}

export const DocumentMetadataSection: React.FC<DocumentMetadataSectionProps> = ({ document }) => (
  <Box
    sx={{
      p: 2,
      backgroundColor: '#f8fafc',
      borderRadius: 2,
      border: '1px solid #e2e8f0',
    }}
  >
    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, color: '#1e293b' }}>
      Document Information
    </Typography>
    <Stack spacing={2}>
      <Box display="flex" alignItems="center" gap={1}>
        <Person sx={{ color: '#64748b', fontSize: 20 }} />
        <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
          Uploaded by:
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {document.uploadedBy || 'Unknown User'}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <CalendarToday sx={{ color: '#64748b', fontSize: 20 }} />
        <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
          Upload date:
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          {formatDate(document.uploadedDate)}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <Description sx={{ color: '#64748b', fontSize: 20 }} />
        <Typography variant="body2" sx={{ color: '#64748b', fontWeight: 500 }}>
          Storage path:
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontFamily: 'monospace',
            fontSize: '0.75rem',
            backgroundColor: '#f1f5f9',
            px: 1,
            py: 0.5,
            borderRadius: 0.5,
          }}
        >
          {`refunds/${document.refundId}/${document.fileName}`}
        </Typography>
      </Box>
    </Stack>
  </Box>
);

export default DocumentMetadataSection;
